import React__default from 'react';
import Box from './Box.js';
import Typography from './Typography.js';
import 'styled-components';
import './useTheme.js';

const MapMarker = ({
  subtitleText,
  testID,
  titleText
}) => {
  return /*#__PURE__*/React__default.createElement(Box, {
    borderRadius: "base",
    boxShadow: "darken",
    display: "inline-block",
    maxWidth: "150px",
    paddingHorizontal: "tiny",
    paddingVertical: "xTiny",
    shapeFill: "senary",
    testID: testID,
    whiteSpace: "nowrap"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "caption-2",
    color: "primary",
    ellipsis: true
  }, titleText), /*#__PURE__*/React__default.createElement(Typography, {
    color: "tertiary",
    ellipsis: true,
    htmlTitle: subtitleText,
    variant: "label-3"
  }, subtitleText));
};

export { MapMarker as default };
//# sourceMappingURL=MapMarker.js.map
